"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = require("prop-types");

var _constant = require("@airasia/phoenix-components/components/Theme/constant");

var _constant2 = require("./constant");

var _default = {
  PropTypes: {
    loginLabel: _propTypes.string,
    deviceType: (0, _propTypes.oneOf)(Object.values(_constant2.DEVICE_TYPE)),
    iconType: _propTypes.string,
    loginMenuData: _propTypes.array,
    HideLoginIconForMobile: _propTypes.bool,
    theme: _propTypes.string,
    doPolling: _propTypes.bool,
    environment: (0, _propTypes.oneOf)(Object.keys(_constant2.ENV)),
    MenuOnLeft: _propTypes.bool,
    shouldSetCookie: _propTypes.bool,
    enableBigPoints: _propTypes.bool,
    enableCreditBalance: _propTypes.bool,
    setDuplicateCookieAATokens: (0, _propTypes.shape)({
      cookieName: _propTypes.string,
      cookieExpiryInDays: _propTypes.number
    }),
    reloadOnLogin: _propTypes.bool,
    reloadOnLogout: _propTypes.bool,
    tooltipdata: _propTypes.array,
    shouldShowTooltip: _propTypes.bool,
    accessible: _propTypes.bool,
    customProperties: _propTypes.object,
    locale: _propTypes.string,
    currency: _propTypes.string,
    onUserLoginStatus: _propTypes.func,
    index: _propTypes.string,
    idConfig: (0, _propTypes.exact)({
      widgetName: _propTypes.string,
      parentName: _propTypes.string,
      index: _propTypes.string
    }),
    isScrollTop: _propTypes.bool
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    deviceType: _constant2.DEFAULT_CONFIG.DEVICE,
    HideLoginIconForMobile: false,
    iconType: _constant2.DEFAULT_CONFIG.ICON.TYPE,
    doPolling: false,
    enableBigPoints: true,
    enableCreditBalance: false,
    environment: _constant2.DEFAULT_CONFIG.ENV,
    MenuOnLeft: false,
    shouldSetCookie: false,
    reloadOnLogin: false,
    reloadOnLogout: true,
    shouldShowTooltip: true,
    locale: _constant2.DEFAULT_CONFIG.LOCALE,
    currency: _constant2.DEFAULT_CONFIG.CURRENCY,
    onUserLoginStatus: function onUserLoginStatus() {},
    isScrollTop: true
  }
};
exports.default = _default;